import { type SurveyElement } from '../MidYearSummary'
import { SummaryHeader } from './SummaryHeader'
import { SummaryPanelDynamic } from './SummaryPanelDynamic'
import { SummaryRadio } from './SummaryRadio'
import { SummaryText } from './SummaryText'

const isVisible = (visibleIf: string | null | undefined, answers: Record<string, any>): boolean => {
  if (visibleIf == null || visibleIf === '') return true
  /**
   * Regular expression match to parse a conditional visibility expression in the format "{fieldName} = 'value'".
   * Captures two groups:
   * - Group 1: The field name (word characters only)
   * - Group 2: The value to compare against (any characters except single quotes)
   *
   * Example: "{status} = 'active'" would capture "status" and "active"
   */
  const match = visibleIf.match(/\{(\w+)\}\s*=\s*'([^']*)'/)
  if (match == null) return true
  const [, questionName, expectedValue] = match
  return answers[questionName] === expectedValue
}

interface Props {
  element: SurveyElement
  answers: Record<string, any>
  isPanelDynamic?: boolean
}
export const SummaryElement = ({ element, answers, isPanelDynamic }: Props): JSX.Element | null => {
  if (!isVisible(element.visibleIf, answers)) return null

  switch (element.type) {
    case 'surveyheader':
      return <SummaryHeader element={element} />
    case 'surveyradio':
      return <SummaryRadio element={element} answers={answers} />
    case 'surveytext':
      return isPanelDynamic === true
        ? null
        : <SummaryText element={element} answers={answers} />
    case 'surveypaneldynamic':
      return <SummaryPanelDynamic element={element} answers={answers} />
    default:
      return null
  }
}
